export const encodeComponentString = element => {
  return JSON.stringify(element, (_k, v) => typeof v === "symbol" ? `$$Symbol:${Symbol.keyFor(v)}` : v);
};